<template lang="pug">
v-container(fluid)
    v-row
        WeekSelector(:isoWeek.sync="selectorIsoWeek" :allowNavigationToPast="true")
    v-row
        v-container.pa-0(v-if="menuOfferCollection === undefined" fluid)
            v-skeleton-loader(type="list-item-three-line@7")
        OfferItem.pt-0.pb-0(
            v-if="menuOfferCollection && menuOfferCollection.length"
            v-for="(menuOfferItem, idx) in menuOfferCollection" :key="idx"
            :offerItem="menuOfferItem" :reservationItem="findReservationItem(menuOfferItem)" :date="date"
            @onChangeDate="onChangeDate"
        )

</template>

<script lang="ts">
import Vue from 'vue'
import moment from 'moment'
import WeekSelector from '@/components/boarder-detail-dialog/CalendarWeekSelector.vue'
import OfferItem from '@/components/boarder-detail-dialog/CalendarOfferItem.vue'
import MenuReservationItem from '@/model/dailymenu/MenuReservationItem'
import {Component, Prop} from "vue-property-decorator";
import DailyMenuOfferOrder from "@/model/dailymenu/DailyMenuOfferOrder";

@Component({
  components: {
    WeekSelector,
    OfferItem
  }
})
export default class Calendar extends Vue {

  @Prop({ type: String, required: true }) readonly isoWeek!: string
  @Prop({ type: Date }) readonly date!: Date
  @Prop({ type: Array as () => DailyMenuOfferOrder[] | undefined }) readonly menuOfferCollection!: DailyMenuOfferOrder[] | undefined
  @Prop({ type: Array as () => MenuReservationItem[] | undefined }) readonly reservationCollection!: MenuReservationItem[] | undefined


    get selectorIsoWeek () {
      return this.isoWeek
    }

    set selectorIsoWeek (newVal: string) {
      this.$emit('update:isoWeek', newVal)
    }

    findReservationItem (offerItem: DailyMenuOfferOrder): MenuReservationItem[] | undefined {
      if (this.reservationCollection) {
        return this.reservationCollection.filter((item: MenuReservationItem) => moment(item.date).isSame(offerItem.date, 'date'))
      }
    }

    onChangeDate (date: string): void {
      this.$emit('update:date', new Date(date))
    }

}
</script>

<style lang="stylus" scoped>
</style>
